import { Loading } from '@fasstech/middle-design-system';
import { isEmpty, isNil } from 'ramda';
import UnavailablePricingModal from '@@viewCommonComponents/displayer/UnavailablePricingModal.jsx';
import { useProcess } from '@fasstech/oip-starter-utils/app';
import useGetSimulationPricingsSelfWorkerQuery from './hooks/useGetSimulationPricingsSelfWorkerQuery.js';
import SimulationPricingsSelfWorkerForm from './SimulationPricingsSelfWorkerForm.jsx';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures';
import { compose } from 'ramda';
import withGlobalData from '@@viewCommonHoc/withGlobalData.jsx';

const SimulationPricingsSelfWorker = ({
  getMiddleText,
  getMiddleBoolean,
  getMiddleNumber,
  usersInformation
}) => {
  const {
    getSimulationPricingsSelfWorker,
    loading: isLoadingGetSimulationPricingsSelfWorker
  } = useGetSimulationPricingsSelfWorkerQuery();

  const { processHandlers, context } = useProcess();

  if (isLoadingGetSimulationPricingsSelfWorker) return <Loading />;

  // If not guarantee -> display the modal
  const { guarantees } = getSimulationPricingsSelfWorker;

  if (isNil(guarantees) || isEmpty(guarantees)) {
    return (
      <UnavailablePricingModal
        getMiddleText={getMiddleText}
        textKey={'NIVEAUXGARANTIESETTARIFS_TARIFICATION_INDISPONIBLE_LABEL'}
        // User can still go back
        onClose={() =>
          processHandlers.onPrev({ context: { projectId: context?.projectId } })
        }
      />
    );
  }

  return (
    <div className="w-full p-0 md:px-4!">
      <SimulationPricingsSelfWorkerForm
        getSimulationPricingsSelfWorker={getSimulationPricingsSelfWorker}
        getMiddleText={getMiddleText}
        getMiddleBoolean={getMiddleBoolean}
        getMiddleNumber={getMiddleNumber}
        usersInformation={usersInformation}
      />
    </div>
  );
};

export default compose(
  withMiddleFeatures,
  withGlobalData
)(SimulationPricingsSelfWorker);
